import { registerCardTemplate } from "../../../common/common";
import { lazyTemplate } from "../../lazyTemplate";

// Eager metadata registration; the render component (SearchWidget) code-splits
// into its own tpl-search-widget chunk, loaded on demand when the widget renders.
registerCardTemplate({
    id: 'search-widget',
    template: lazyTemplate(() => import(/* webpackChunkName: "tpl-search-widget" */ "./SearchWidget")),
    name: 'Search Widget',
    description: 'Configurable search widget',
    complexity: 'medium',
    layout: {
        w: 9,
        h: 14
    },
    canDragDropFields: true,
    icon: "search"
});
